<template>
  <main>
    <Loader :loader="loader" />
    <div
      class="w-full min-h-[800px] max-w-[900px] py-2 px-4"
      v-if="!loader && chapters.length > 0"
    >
      <Accordion class="accordion-objective-custom">
        <AccordionTab v-for="(chapter, i) in chapters" :key="i">
          <template #header>
            <div class="flex justify-between items-center w-full">
              <h6 class="text-neutral-800 font-[700]">{{ chapter.name }}</h6>
              <Button
                :id="`chapter-edit-btn`"
                class="btn-simple w-10"
                v-if="role == 'TEACHER'"
                @click="goToEditChapter(chapter.id, 0)"
              >
                <v-icon name="hi-solid-pencil" />
              </Button>
            </div>
          </template>
          <div class="min-h-[200px] flex flex-col gap-2 py-4 px-2">
            <div
              class="flex flex-col justify-center items-center gap-6"
              v-if="chapter.trails.length == 0"
            >
              <EmptyData
                :data="true"
                :title="`${$t('labels.generic', {
                  pt: 'Nenhum objetivo adicionado',
                  en: 'No objectives added',
                })}`"
                :label="`${$t('labels.generic', {
                  pt: 'Os objetivos ficarão listados aqui. Clique em “Adicionar objetivos” para ver esses itens.',
                  en: 'The objectives will be listed here. Click “Add objectives” to view these items.',
                })}`"
                :image="'empty-objectives.svg'"
                imgSize="h-40"
              />

              <Button
                class="btn-outline-bg-white"
                v-if="role == 'TEACHER'"
                @click="goToEditChapter(chapter.id, 1)"
                >{{
                  $t("labels.generic", {
                    pt: "Adicionar objetivos",
                    en: "Add objectives",
                  })
                }}</Button
              >
            </div>
            <ListObjective
              v-else
              v-for="(objective, j) in chapter.trails"
              :key="j"
              :objective="objective"
              :chapter="chapter"
              :courseId="courseId"
              :role="role"
            />
          </div>
        </AccordionTab>
      </Accordion>
    </div>
    <div class="h-screen bg-neutral-50 pt-32" v-else>
      <div>
        <EmptyData
          :data="true"
          :title="`${$t('labels.generic', {
            pt: 'Nenhum capítulo adicionado',
            en: 'No chapter added',
          })}`"
          :label="`${$t('labels.generic', {
            pt: 'Os capítulos ficarão listados aqui. Clique em “Adicionar capítulo” para ver esses itens.',
            en: 'The chapters will be listed here. Click “Add chapter” to view these items.',
          })}`"
          :image="'empty-chapters.svg'"
          imgSize="h-40"
        />
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { ChaptersService } from "../chapters.service";
import { GoToRoute } from "@/utils/go-to.util";
import { Material } from "@/models/material.model";
import { LearningObjective } from "@/models/learning-objective.model";
import { GenericsUtils } from "@/utils/generics.util";
import { last, take } from "rxjs";
import { MaterialsRest } from "@/services/rest/materials.rest";

export default defineComponent({
  name: "traditionalChapters",
  props: {
    role: [String],
    data: { type: Object as PropType<any>, default: {} },
  },
  computed: {
    service(): ChaptersService {
      return new ChaptersService();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
    generics(): GenericsUtils {
      return new GenericsUtils();
    },
    rest(): MaterialsRest {
      return new MaterialsRest();
    },
  },
  data() {
    return {
      courseId: this.$route.params.id as string,
      chapters: [] as any,
      currentMaterials: [] as Material[],

      currentObjective: {} as LearningObjective,
      loader: true as boolean,
    };
  },
  mounted() {
    this.getChaptersByTraditional();
  },
  methods: {
    getChaptersByTraditional(): void {
      if (!this.data.adaptive) {
        this.service.chapters.pipe(take(2), last()).subscribe({
          next: (response) => {
            this.chapters = response;
            this.loader = false;
            this.getSecureUrl();
          },
        });
        this.service.getCourseTraditional(this.courseId);
      }
    },
    goToEditChapter(chapterId: string, tab: number): void {
      let params = {
        courseId: this.$route.params.id,
        chapterId: chapterId,
        tab: tab,
      };
      this.go.redirectToPage("formChapterTraditional", params);
    },

    getSecureUrl(): void {},
  },
});
</script>
